// extracted by mini-css-extract-plugin
export var alertIcon = "_vb-0";